import React from 'react';
import { motion } from 'framer-motion';
import AppImage from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';


const WelcomeHero = () => {
  return (
    <div 
      className="relative overflow-hidden mb-16 min-h-[500px]"
      style={{
        backgroundImage: 'url(/assets/images/Corperconnect_hero_image-1765361221543.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Enhanced dark overlay for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative z-10 text-center py-12 px-4"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="inline-flex items-center justify-center mb-6"
        >
          <AppImage 
            src="/assets/images/NYSC_logo-1765293658432.png" 
            alt="National Youth Service Corps (NYSC) official logo - CorperConnect platform emblem"
            className="w-24 h-24 object-contain drop-shadow-2xl"
          />
        </motion.div>
        
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 font-accent drop-shadow-2xl" style={{ textShadow: '0 4px 8px rgba(0,0,0,0.8), 0 2px 4px rgba(0,0,0,0.6)' }}>
          WELCOME TO YOUR NEXT CHAPTER
        </h1>
        
        <p className="text-2xl md:text-3xl text-white max-w-3xl mx-auto mb-8 leading-relaxed tracking-wide font-light antialiased drop-shadow-2xl" style={{ textShadow: '0 3px 6px rgba(0,0,0,0.8), 0 1px 3px rgba(0,0,0,0.6)' }}>
          Your journey starts here. Select your company to begin an exciting onboarding experience designed for young professionals like you.
        </p>
        
        <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-white">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-success bg-opacity-30 rounded-full flex items-center justify-center backdrop-blur-sm shadow-lg">
              <Icon name="Shield" size={16} color="white" />
            </div>
            <span className="drop-shadow-lg font-medium" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.8)' }}>Secure & Encrypted</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-primary bg-opacity-30 rounded-full flex items-center justify-center backdrop-blur-sm shadow-lg">
              <Icon name="Clock" size={16} color="white" />
            </div>
            <span className="drop-shadow-lg font-medium" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.8)' }}>5-10 Minutes</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-accent bg-opacity-30 rounded-full flex items-center justify-center backdrop-blur-sm shadow-lg">
              <Icon name="Save" size={16} color="white" />
            </div>
            <span className="drop-shadow-lg font-medium" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.8)' }}>Save & Continue</span>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default WelcomeHero;